import { createContext, useContext } from 'react';
import type { TooltipRenderProps } from 'react-joyride';

export interface ITourPresentation {
    tourId: string;
    props: TooltipRenderProps;
}

export function createTourPresentationStore() {
    let snapshot: ITourPresentation | null = null;
    const listeners = new Set<() => void>();
    return {
        getSnapshot: () => snapshot,
        subscribe: (listener: () => void) => {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        publish: (next: ITourPresentation) => {
            snapshot = next;
            listeners.forEach((listener) => listener());
        },
    };
}

export type TourPresentationStore = ReturnType<typeof createTourPresentationStore>;

export const TourPresentationContext = createContext<{ store: TourPresentationStore; tourId: string } | null>(null);
export const useTourPresentation = () => useContext(TourPresentationContext);
